<template>
  <div>
    <div
      class="modal fade prdtmodel-nw orders-tab-main cust-prdt-table nw-prdt-detail product-details-popup"
      id="item-popup"
      tabindex="-1"
      aria-labelledby="itemModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content h-auto">
          <div class="modal-header product-modal-header">
            <div class="cust-modal-header">
              <skeleton-loader-vue
                v-if="!productDetail"
                type="string"
                width="50%"
                height="20px"
              />
              <!-- <h5 v-else class="modal-title" id="itemModalLabel">
                {{ productDetail.item_name }}
              </h5> -->
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <!-- <span aria-hidden="true">&times;</span> -->
                <svg
                  fill="#000000"
                  width="25px"
                  height="25px"
                  viewBox="0 0 32 32"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                  <g
                    id="SVGRepo_tracerCarrier"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></g>
                  <g id="SVGRepo_iconCarrier">
                    <path
                      d="M16 0c-8.836 0-16 7.163-16 16s7.163 16 16 16c8.837 0 16-7.163 16-16s-7.163-16-16-16zM16 30.032c-7.72 0-14-6.312-14-14.032s6.28-14 14-14 14 6.28 14 14-6.28 14.032-14 14.032zM21.657 10.344c-0.39-0.39-1.023-0.39-1.414 0l-4.242 4.242-4.242-4.242c-0.39-0.39-1.024-0.39-1.415 0s-0.39 1.024 0 1.414l4.242 4.242-4.242 4.242c-0.39 0.39-0.39 1.024 0 1.414s1.024 0.39 1.415 0l4.242-4.242 4.242 4.242c0.39 0.39 1.023 0.39 1.414 0s0.39-1.024 0-1.414l-4.242-4.242 4.242-4.242c0.391-0.391 0.391-1.024 0-1.414z"
                    ></path>
                  </g>
                </svg>
              </button>
            </div>
            <!-- <div class="tags-list" v-if="tags && tags.length > 0">
              <ul>
                <li
                  v-for="(tag, i) in tags"
                  :key="i"
                  :class="tag.name.toLowerCase()"
                  :style="{
                    background: tag.background_color + '!important',
                    color: tag.text_color + '!important',
                  }"
                >
                  {{ tag.name }}
                </li>
              </ul>
            </div> -->
          </div>
          <!---------Customization Skeleton start------------->
          <div class="container" v-if="customize_skelloader">
            <div class="product-content pt-3">
              <div>
                <div class="cus-title">
                  <skeleton-loader-vue
                    type="string"
                    width="37%"
                    height="20px"
                  />
                  <skeleton-loader-vue
                    type="string"
                    width="20%"
                    height="20px"
                  />
                </div>
                <div>
                  <div class="">
                    <label
                      for="radio-0-0"
                      class="form__label-radio"
                      style="padding-left: 0px"
                    >
                      <skeleton-loader-vue
                        type="circle"
                        class="form__radio"
                        width="20px"
                        height="20px"
                        style="margin-right: 20px"
                      />
                      <skeleton-loader-vue
                        type="string"
                        width="170px"
                        height="20px"
                        style="position: absolute"
                      />
                    </label>

                    <span class="ch-price"
                      ><skeleton-loader-vue
                        type="string"
                        width="30px"
                        height="24px"
                    /></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!---------Customization Skeleton End------------->
          <div
            class="modal-body cust-modal-body"
            v-if="productDetail"
            :id="'item-id-' + productDetail.item_id"
          >
            <VueSlickCarousel
              v-bind="settings"
              id="prod-details-slider"
              class="silkprod"
              v-if="productDetail.item_images.length > 0"
            >
              <div
                v-for="(slide, index) in productDetail.item_images"
                :key="index"
              >
                <div
                  class="testimonial-item equal-height style-6"
                  v-if="!imgError"
                >
                  <img
                    class="item-img"
                    :src="slide.image_name"
                    @error="imageErrorHandle"
                  />
                </div>
              </div>
            </VueSlickCarousel>

            <div class="desciption-wrappper">
              <div class="tag-type-wrapper d-flex align-content-center">
                <div class="tag-list-details">
                  <div class="veg" v-if="productDetail.item_type == 0">
                    <span></span>
                  </div>
                  <div class="non-veg" v-if="productDetail.item_type == 1">
                    <img
                      class="non-veg-img"
                      src="@/assets/images/non_veg.png"
                    />
                  </div>
                </div>
                <!-- <div class="best-saller-tag">
                  <svg width="13" height="13" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_1_12587)">
                      <path
                        d="M6 11.5C9.03757 11.5 11.5 9.03757 11.5 6C11.5 2.96243 9.03757 0.5 6 0.5C2.96243 0.5 0.5 2.96243 0.5 6C0.5 9.03757 2.96243 11.5 6 11.5Z"
                        fill="#FEDB41" stroke="#FE9923" />
                      <path
                        d="M5.14595 4.02251C5.52594 3.34084 5.71594 3 6 3C6.28406 3 6.47406 3.34084 6.85405 4.02251L6.95236 4.19887C7.06034 4.39258 7.11433 4.48944 7.19852 4.55334C7.2827 4.61725 7.38754 4.64097 7.59723 4.68841L7.78814 4.73161C8.52604 4.89857 8.89499 4.98205 8.98277 5.26432C9.07055 5.54659 8.81903 5.84072 8.31597 6.42898L8.18582 6.58117C8.04287 6.74833 7.9714 6.83191 7.93924 6.93531C7.90709 7.03872 7.91789 7.15023 7.9395 7.37327L7.95918 7.57632C8.03524 8.36118 8.07326 8.75361 7.84346 8.92807C7.61365 9.10252 7.2682 8.94346 6.5773 8.62535L6.39855 8.54305C6.20222 8.45265 6.10406 8.40745 6 8.40745C5.89594 8.40745 5.79778 8.45265 5.60145 8.54305L5.4227 8.62535C4.7318 8.94346 4.38635 9.10252 4.15654 8.92807C3.92674 8.75361 3.96476 8.36118 4.04082 7.57632L4.0605 7.37327C4.08211 7.15023 4.09291 7.03872 4.06076 6.93531C4.0286 6.83191 3.95713 6.74833 3.81418 6.58117L3.68403 6.42898C3.18097 5.84072 2.92945 5.54659 3.01723 5.26432C3.10501 4.98205 3.47396 4.89857 4.21186 4.73161L4.40277 4.68841C4.61246 4.64097 4.7173 4.61725 4.80148 4.55334C4.88567 4.48944 4.93966 4.39258 5.04764 4.19887L5.14595 4.02251Z"
                        fill="#FE9923" />
                    </g>
                    <defs>
                      <clipPath id="clip0_1_12587">
                        <rect width="12" height="12" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                  <p>Bestseller</p>
                </div> -->
              </div>

              <div class="desciption-title-descripion">
                <div class="tags-list" v-if="tags && tags.length > 0">
                  <ul>
                    <li
                      v-for="(tag, i) in tags"
                      :key="i"
                      :class="tag.name.toLowerCase()"
                      :style="{
                        background: tag.background_color + '!important',
                        color: tag.text_color + '!important',
                      }"
                    >
                      {{ tag.name }}
                    </li>
                  </ul>
                </div>
                <h5>
                  {{ productDetail.item_name }}
                </h5>
                

                <div class="desciption-content">
                  {{ productDetail.item_description }}
                </div>
                
                <div
                  class="tags-list mb-1"
                  v-if="
                    getOfferes(productDetail.item_id) &&
                    getOfferes(productDetail.item_id).length > 0
                  "
                >
                  <ul>
                    <template
                      v-for="(tag, i) in getOfferes(productDetail.item_id)"
                    >
                      <li
                        :key="i"
                        class="fw-bolder"
                        v-if="tag.coupon_type == couponTypes.BOGO"
                      >
                        {{ tag.title }}
                      </li>
                    </template>
                  </ul>
                </div>

                <div
                  class="price-name"
                  v-if="getOfferes(productDetail.item_id).length > 0"
                >
                  <span v-html="$auth.setting.currency" class="currency"></span>
                  {{
                    getOfferedPrice(
                      getOfferes(productDetail.item_id),
                      productDetail.display_price
                    )
                  }}
                </div>
                <div class="price-name" v-else>
                  <span v-html="$auth.setting.currency" class="currency"></span>
                  {{ productDetail.display_price }}
                </div>
              </div>
            </div>

            <div class="customization-wrapper"></div>

            <!-- <ul class="nav nav-tabs border-0 mb-3" v-if="
              productDetail.is_customizable == 1 &&
              productDetail.item_description
            ">
              <li class="nav-item">
                <a href="#sort" class="nav-link navbar-default"
                  :class="productDetail.is_customizable != 0 ? 'active' : ''" v-if="productDetail.is_customizable != 0"
                  data-toggle="tab">{{ $t("Customization") }}</a>
              </li>
              <li class="nav-item" v-if="
                productDetail.item_description ||
                productDetail.custom_details.length > 0
              ">
                <a href="#cusines" class="nav-link navbar-default" data-toggle="tab">{{ $t("Description") }}</a>
              </li>
            </ul> -->
            <form action="#">
              <div class="tab-content">
                <div
                  id="sort"
                  class="tab-pane active tab-box"
                  v-if="productDetail.is_customizable != 0"
                >
                  <div class="container">
                    <div
                      class="product-content pt-3"
                      v-if="
                        productDetail.is_customizable != '0' &&
                        !customize_skelloader
                      "
                    >
                      <div
                        v-for="(
                          customize, customizeIndex
                        ) in productDetail.customize_type"
                        :key="customizeIndex"
                      >
                        <div class="cus-title">
                          <h6 class="cus-name">
                            <!-- {{ customize.name }} -->
                            Options
                            <div
                              class="maximum-items"
                              v-if="customize.is_selection != 0"
                            >
                              <span>
                                Select any
                                {{ customize.is_selection }} items</span
                              >
                            </div>
                          </h6>
                          <p class="required-tag">REQUIRED</p>
                        </div>
                        <!--Radio Button start-->
                        <div
                          v-if="
                            customize.is_min_selection == '1' &&
                            customize.is_selection == '1'
                          "
                          :class="{
                            'is-invalid':
                              $v.selectedCustomisation.customize_type[
                                'parent_' + customize.customize_type_id
                              ].value.$error,
                          }"
                        >
                          <div
                            class="form-check form__radio-group"
                            v-for="(optionData, index) in customize.option"
                            :key="index"
                          >
                            <div
                              data-toggle="collapse"
                              class="rdiotogl"
                              :href="
                                '#collapseExample' + customizeIndex + index
                              "
                            >
                              <input
                                class="form__radio-input"
                                type="radio"
                                :name="'radio-' + customizeIndex"
                                :id="'radio-' + customizeIndex + '-' + index"
                                :value="optionData.selection_id"
                                v-model="
                                  $v.selectedCustomisation.customize_type[
                                    'parent_' + customize.customize_type_id
                                  ].value.$model
                                "
                                @change="
                                  checkNested(
                                    $event,
                                    customize.customize_type_id
                                  )
                                "
                                :checked="optionData.is_default == '1'"
                              />
                              <label
                                class="form__label-radio"
                                :for="'radio-' + customizeIndex + '-' + index"
                                ><span class="form__radio-button"></span
                                >{{ optionData.selection_name }}</label
                              >
                              <div class="">
                                <span
                                  class="ch-price strikeout"
                                  v-if="
                                    customizationPrice(
                                      index,
                                      optionData,
                                      productDetail.item_id
                                    ) < optionData.selection_price
                                  "
                                  ><span
                                    v-html="
                                      $auth.setting && $auth.setting.currency
                                    "
                                    class="currency"
                                  ></span
                                  >{{ optionData.selection_price }}</span
                                >
                                <span class="ch-price">
                                  <span
                                    v-html="$auth.setting.currency"
                                    class="currency"
                                  ></span>
                                  {{
                                    customizationPrice(
                                      index,
                                      optionData,
                                      productDetail.item_id
                                    )
                                  }}
                                  <b-icon-arrow-right-circle-fill
                                    v-if="optionData.options.length > 0"
                                  ></b-icon-arrow-right-circle-fill>
                                </span>
                              </div>
                            </div>
                            <!--------Sub Customization Start Radio------------->
                            <div
                              class="rdiotogllist"
                              v-if="
                                optionData.is_min_selection == '1' &&
                                optionData.is_selection == '1' &&
                                optionData.options.length > 0
                              "
                            >
                              <div
                                class="chld-rdio collapse show"
                                :class="{
                                  'is-invalid':
                                    $v.selectedCustomisation.customize_type[
                                      'parent_' + customize.customize_type_id
                                    ]['child_' + optionData.selection_id].value
                                      .$error,
                                }"
                                v-if="
                                  optionData.options.length > 0 &&
                                  selectedCustomisation.customize_type[
                                    'parent_' + customize.customize_type_id
                                  ].value == optionData.selection_id
                                "
                              >
                                <div
                                  v-for="(
                                    subOption, subi
                                  ) in optionData.options"
                                  :key="subi"
                                  class="form-check form__radio-group"
                                >
                                  <!-- v-model="productDetail.selected_type[customizeIndex].subradio"  -->
                                  <input
                                    class="form__radio-input"
                                    type="radio"
                                    :name="
                                      'radio-' + index + '-' + customizeIndex
                                    "
                                    :id="
                                      'radio-' +
                                      customizeIndex +
                                      '-' +
                                      index +
                                      '-' +
                                      subi
                                    "
                                    :value="subOption.selection_id"
                                    v-model="
                                      $v.selectedCustomisation.customize_type[
                                        'parent_' + customize.customize_type_id
                                      ]['child_' + optionData.selection_id]
                                        .value.$model
                                    "
                                    @change="
                                      checkNestedSub(
                                        $event,
                                        subOption.selection_id
                                      )
                                    "
                                    :checked="subOption.is_default == '1'"
                                  />
                                  {{ subOption.is_selected }}
                                  <label
                                    class="form__label-radio"
                                    :for="
                                      'radio-' +
                                      customizeIndex +
                                      '-' +
                                      index +
                                      '-' +
                                      subi
                                    "
                                    ><span class="form__radio-button"></span
                                    >{{ subOption.selection_name }}</label
                                  >

                                  <div class="">
                                    <span
                                      class="ch-price strikeout"
                                      v-if="
                                        customizationPrice(
                                          subi,
                                          subOption,
                                          productDetail.item_id
                                        ) < subOption.selection_price
                                      "
                                      ><span
                                        v-html="
                                          $auth.setting &&
                                          $auth.setting.currency
                                        "
                                        class="currency"
                                      ></span
                                      >{{ subOption.selection_price }}</span
                                    >

                                    <span class="ch-price"
                                      ><span
                                        v-html="$auth.setting.currency"
                                        class="currency"
                                      ></span
                                      >{{
                                        customizationPrice(
                                          subi,
                                          subOption,
                                          productDetail.item_id
                                        )
                                      }}</span
                                    >
                                  </div>
                                </div>
                              </div>

                              <div class="invalid-feedback">
                                <span
                                  v-if="
                                    !$v.selectedCustomisation.customize_type[
                                      'parent_' + customize.customize_type_id
                                    ]['child_' + optionData.selection_id].value
                                      .crequired
                                  "
                                  >{{ optionData.selection_name }}
                                  {{ $t("Maximum") }}
                                  {{ optionData.is_selection }}
                                  {{ $t("item select") }}</span
                                >
                                <span
                                  v-else-if="
                                    !$v.selectedCustomisation.customize_type[
                                      'parent_' + customize.customize_type_id
                                    ]['child_' + optionData.selection_id].value
                                      .valueBetween
                                  "
                                  >{{ optionData.selection_name }}
                                  {{ $t("Maximum") }}
                                  {{ optionData.is_selection }}
                                  {{ $t("item select valid") }}</span
                                >
                              </div>
                            </div>
                            <!---------Sub Customization End Radio------------>
                            <!---------Sub Customization Start Checkbox------------>
                            <div v-else class="custom-checkbox">
                              <div
                                class="chld-rdio collapse show"
                                :class="{
                                  'is-invalid':
                                    $v.selectedCustomisation.customize_type[
                                      'parent_' + customize.customize_type_id
                                    ]['child_' + optionData.selection_id].value
                                      .$error,
                                }"
                                v-if="
                                  optionData.options.length > 0 &&
                                  selectedCustomisation.customize_type[
                                    'parent_' + customize.customize_type_id
                                  ].value == optionData.selection_id
                                "
                              >
                                <div
                                  class="form-group"
                                  v-for="(
                                    suboptionCheckbox, subindex
                                  ) in optionData.options"
                                  :key="subindex"
                                >
                                  <!-- v-model="productDetail.selected_type[customizeIndex].subcheckbox" -->
                                  <input
                                    class="form-check-input"
                                    type="checkbox"
                                     :true-value="suboptionCheckbox.selection_id"
                                    :false-value="null"
                                    :value="suboptionCheckbox.selection_id"
                                    :id="
                                      'subcheckbox-' +
                                      customizeIndex +
                                      '-' +
                                      index +
                                      '-' +
                                      subindex
                                    "
                                    :name="
                                      'subcheckbox_' +
                                      customizeIndex +
                                      index +
                                      '_' +
                                      subindex
                                    "
                                    v-model="
                                      $v.selectedCustomisation.customize_type[
                                        'parent_' + customize.customize_type_id
                                      ]['child_' + optionData.selection_id]
                                        .value.$model
                                    "
                                    @change="checkNestedSub($event)"
                                  />{{ suboptionCheckbox.is_selected }}
                                  <label
                                    class="form-check-label"
                                    :for="
                                      'subcheckbox-' +
                                      customizeIndex +
                                      '-' +
                                      index +
                                      '-' +
                                      subindex
                                    "
                                  >
                                    {{
                                      suboptionCheckbox.selection_name
                                    }}</label
                                  >
                                  <span class="ch-price"
                                    ><span
                                      v-html="$auth.setting.currency"
                                      class="currency"
                                    ></span
                                    >{{
                                      suboptionCheckbox.selection_price
                                    }}</span
                                  >
                                </div>
                              </div>
                              <div class="invalid-feedback">
                                <span
                                  v-if="
                                    !$v.selectedCustomisation.customize_type[
                                      'parent_' + customize.customize_type_id
                                    ]['child_' + optionData.selection_id].value
                                      .crequired
                                  "
                                  >{{ optionData.selection_name }} Maximum
                                  {{ optionData.is_selection }} item
                                  select</span
                                >
                                <span
                                  v-else-if="
                                    !$v.selectedCustomisation.customize_type[
                                      'parent_' + customize.customize_type_id
                                    ]['child_' + optionData.selection_id].value
                                      .valueBetween
                                  "
                                  >{{ optionData.selection_name }} Maximum
                                  {{ optionData.is_selection }} item select
                                  valid</span
                                >
                              </div>
                            </div>
                            <!---------Sub Customization End Checkbox------------>
                          </div>
                        </div>
                        <!--Radio Button end-->
                        <!--CheckBox start-->
                        <div
                          v-else
                          class="custom-checkbox"
                          :class="{
                            'is-invalid':
                              $v.selectedCustomisation.customize_type[
                                'parent_' + customize.customize_type_id
                              ].value.$error,
                          }"
                        >
                          <div
                            v-for="(optionData, index) in customize.option"
                            :key="index"
                          >
                            <div class="form-group">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                :value="optionData.selection_id"
                                :id="'checkbox-' + customizeIndex + '-' + index"
                                :name="'checkbox_' + customizeIndex"
                                :true-value="optionData.selection_id"
                                :false-value="null"
                                v-model="
                                  $v.selectedCustomisation.customize_type[
                                    'parent_' + customize.customize_type_id
                                  ].value.$model
                                "
                                @change="
                                  checkNestedSub(
                                    $event,
                                    customize.customize_type_id
                                  )
                                "
                                :checked="optionData.is_default == '1'"
                              />
                              <label
                                class="form-check-label"
                                :for="
                                  'checkbox-' + customizeIndex + '-' + index
                                "
                              >
                                {{ optionData.selection_name }}
                                {{ customize.customizeIndex }}</label
                              >
                              <div>
                                <span
                                  class="ch-price strikeout"
                                  v-if="
                                    customizationPrice(
                                      index,
                                      optionData,
                                      productDetail.item_id
                                    ) < optionData.selection_price
                                  "
                                  ><span
                                    v-html="
                                      $auth.setting && $auth.setting.currency
                                    "
                                    class="currency"
                                  ></span
                                  >{{ optionData.selection_price }}</span
                                >
                                <span class="ch-price"
                                  ><span
                                    v-html="$auth.setting.currency"
                                    class="currency"
                                  ></span
                                  >{{
                                    customizationPrice(
                                      index,
                                      optionData,
                                      productDetail.item_id
                                    )
                                  }}
                                  <b-icon-arrow-right-circle-fill
                                    v-if="optionData.options.length > 0"
                                  ></b-icon-arrow-right-circle-fill
                                ></span>
                              </div>
                            </div>
                            <!--------Sub Customization Start Radio------------->
                            <div
                              v-if="
                                optionData.is_min_selection == '1' &&
                                optionData.is_selection == '1' &&
                                optionData.options.length > 0
                              "
                            >
                              <div
                                class="chld-rdio"
                                :class="{
                                  'is-invalid':
                                    $v.selectedCustomisation.customize_type[
                                      'parent_' + customize.customize_type_id
                                    ]['child_' + optionData.selection_id].value
                                      .$error,
                                }"
                                v-if="
                                  optionData.options.length > 0 &&
                                  selectedCustomisation.customize_type[
                                    'parent_' + customize.customize_type_id
                                  ].value == optionData.selection_id
                                "
                              >
                                <div
                                  v-for="(
                                    subOption, subi
                                  ) in optionData.options"
                                  :key="subi"
                                  class="form-check form__radio-group"
                                >
                                  <!-- v-model="productDetail.selected_type[customizeIndex].subradio"  -->
                                  <input
                                    class="form__radio-input"
                                    type="radio"
                                    :name="
                                      'radio-' + index + '-' + customizeIndex
                                    "
                                    :id="
                                      'radio-' +
                                      customizeIndex +
                                      '-' +
                                      index +
                                      '-' +
                                      subi
                                    "
                                    :value="subOption.selection_id"
                                    v-model="
                                      $v.selectedCustomisation.customize_type[
                                        'parent_' + customize.customize_type_id
                                      ]['child_' + optionData.selection_id]
                                        .value.$model
                                    "
                                    @change="checkNestedSub($event)"
                                  />
                                  {{ subOption.is_selected }}
                                  <label
                                    class="form__label-radio"
                                    :for="
                                      'radio-' +
                                      customizeIndex +
                                      '-' +
                                      index +
                                      '-' +
                                      subi
                                    "
                                    ><span class="form__radio-button"></span
                                    >{{ subOption.selection_name }}</label
                                  >
                                  <span class="ch-price"
                                    ><span
                                      v-html="$auth.setting.currency"
                                      class="currency"
                                    ></span
                                    >{{ subOption.selection_price }}</span
                                  >
                                </div>
                              </div>
                              <div class="invalid-feedback">
                                <span
                                  v-if="
                                    !$v.selectedCustomisation.customize_type[
                                      'parent_' + customize.customize_type_id
                                    ]['child_' + optionData.selection_id].value
                                      .crequired
                                  "
                                  >{{ optionData.selection_name }}
                                  {{ $t("Maximum 1 item select") }}</span
                                >
                                <span
                                  v-else-if="
                                    !$v.selectedCustomisation.customize_type[
                                      'parent_' + customize.customize_type_id
                                    ]['child_' + optionData.selection_id].value
                                      .valueBetween
                                  "
                                  >{{ optionData.selection_name }}
                                  {{ $t("Maximum 1 item select valid") }}</span
                                >
                              </div>
                            </div>
                            <!---------Sub Customization End Radio------------>
                            <!---------Sub Customization Start Checkbox------------>
                            <div v-else class="custom-checkbox">
                              <div
                                class="chld-rdio"
                                :class="{
                                  'is-invalid':
                                    $v.selectedCustomisation.customize_type[
                                      'parent_' + customize.customize_type_id
                                    ]['child_' + optionData.selection_id].value
                                      .$error,
                                }"
                                v-if="
                                  optionData.options.length > 0 &&
                                  selectedCustomisation.customize_type[
                                    'parent_' + customize.customize_type_id
                                  ].value &&
                                  selectedCustomisation.customize_type[
                                    'parent_' + customize.customize_type_id
                                  ].value.includes(optionData.selection_id)
                                "
                              >
                                <div
                                  class="form-group"
                                  v-for="(
                                    suboptionCheckbox, subindex
                                  ) in optionData.options"
                                  :key="subindex"
                                >
                                  <!-- v-model="productDetail.selected_type[customizeIndex].subcheckbox" -->
                                  <input
                                    class="form-check-input"
                                    :data-id="
                                      customize.customize_type_id +
                                      ',' +
                                      optionData.selection_id
                                    "
                                    type="checkbox"
                                    :true-value="suboptionCheckbox.selection_id"
                                     :false-value="null"
                                    :value="suboptionCheckbox.selection_id"
                                    :id="
                                      'subcheckbox-' +
                                      customizeIndex +
                                      '-' +
                                      index +
                                      '-' +
                                      subindex
                                    "
                                    v-model="
                                      $v.selectedCustomisation.customize_type[
                                        'parent_' + customize.customize_type_id
                                      ]['child_' + optionData.selection_id]
                                        .value.$model
                                    "
                                    @change="checkNestedSub($event)"
                                  />{{ suboptionCheckbox.is_selected }}
                                  <label
                                    class="form-check-label"
                                    :for="
                                      'subcheckbox-' +
                                      customizeIndex +
                                      '-' +
                                      index +
                                      '-' +
                                      subindex
                                    "
                                  >
                                    {{
                                      suboptionCheckbox.selection_name
                                    }}</label
                                  >
                                  <div>
                                    <span
                                      class="ch-price strikeout"
                                      v-if="
                                        customizationPrice(
                                          subindex,
                                          suboptionCheckbox,
                                          productDetail.item_id
                                        ) < suboptionCheckbox.selection_price
                                      "
                                      ><span
                                        v-html="
                                          $auth.setting &&
                                          $auth.setting.currency
                                        "
                                        class="currency"
                                      ></span
                                      >{{
                                        suboptionCheckbox.selection_price
                                      }}</span
                                    >
                                    <span class="ch-price"
                                      ><span
                                        v-html="$auth.setting.currency"
                                        class="currency"
                                      ></span
                                      >{{
                                        customizationPrice(
                                          subindex,
                                          suboptionCheckbox,
                                          productDetail.item_id
                                        )
                                      }}</span
                                    >
                                  </div>
                                </div>
                              </div>
                              <div class="invalid-feedback">
                                <span
                                  v-if="
                                    !$v.selectedCustomisation.customize_type[
                                      'parent_' + customize.customize_type_id
                                    ]['child_' + optionData.selection_id].value
                                      .crequired
                                  "
                                  >{{ optionData.selection_name }}
                                  {{ $t("Maximum") }}
                                  {{ optionData.is_selection }}
                                  {{ $t("item select") }}</span
                                >
                                <span
                                  v-else-if="
                                    !$v.selectedCustomisation.customize_type[
                                      'parent_' + customize.customize_type_id
                                    ]['child_' + optionData.selection_id].value
                                      .valueBetween
                                  "
                                  >{{ optionData.selection_name }}
                                  {{ $t("Maximum") }}
                                  {{ optionData.is_selection }}
                                  {{ $t("item select valid") }}</span
                                >
                              </div>
                            </div>
                            <!---------Sub Customization End Checkbox------------>
                          </div>
                        </div>
                        <!--CheckBox end-->
                        <div
                          class="invalid-feedback"
                          v-if="
                            $v.selectedCustomisation.customize_type[
                              'parent_' + customize.customize_type_id
                            ].value.$error
                          "
                        >
                          <span
                            v-if="
                              !$v.selectedCustomisation.customize_type[
                                'parent_' + customize.customize_type_id
                              ].value.crequired
                            "
                          >
                            <span v-if="customize.is_min_selection == 1"
                              >{{ customize.name }}
                              {{ $t("Required Minimun 1 item select") }}</span
                            >
                            <span v-if="customize.is_min_selection != 1"
                              >{{ customize.name }}
                              {{ $t("Required Minimum") }}
                              {{ customize.is_min_selection }}
                              {{ $t("items") }}</span
                            >
                          </span>
                          <span
                            v-else-if="
                              !$v.selectedCustomisation.customize_type[
                                'parent_' + customize.customize_type_id
                              ].value.valueBetween
                            "
                          >
                            <span v-if="customize.is_min_selection == 1"
                              >{{ customize.name }}
                              {{ $t("Required Minimun 1 item select") }}</span
                            >
                            <span v-if="customize.is_min_selection != 1"
                              >{{ customize.name }}
                              {{ $t("Required Minimum") }}
                              {{ customize.is_selection }}
                              {{ $t("items") }}</span
                            >
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  id="cusines"
                  class="tab-pane tab-box"
                  :class="
                    productDetail.is_customizable == 0 &&
                    (productDetail.item_description ||
                      productDetail.custom_details.length != 0)
                      ? 'active'
                      : ''
                  "
                >
                  <div class="accordion mt-4" id="accordionExample">
                    <div
                      class="card border-0 description-body"
                      v-if="productDetail.item_description"
                    >
                      <!-- <div class="card-body">
                        {{ productDetail.item_description }}
                      </div> -->
                      <!-- <div class="card-header" id="headingOne">
                                        <h2 class="mb-0">
                                            <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">Description</button>
                                        </h2>
                                    </div>
                                    <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
                                        <div class="card-body">
                                            {{ productDetail.item_description }}
                                        </div>
                                    </div> -->
                    </div>
                    <div v-if="productDetail.custom_details.length > 0">
                      <div
                        class="card"
                        v-for="(detail, index) in productDetail.custom_details"
                        :key="index + 1"
                      >
                        <div class="card-header" :id="`headingOne-${index}`">
                          <h2 class="mb-0">
                            <button
                              class="btn btn-link btn-block text-left"
                              type="button"
                              data-toggle="collapse"
                              :data-target="`#collapseOne-${index}`"
                              aria-expanded="true"
                              :aria-controls="`collapseOne-${index}`"
                            >
                              {{ detail.custom_key }}
                            </button>
                          </h2>
                        </div>
                        <div
                          :id="`collapseOne-${index}`"
                          class="collapse"
                          :aria-labelledby="`headingOne-${index}`"
                          data-parent="#accordionExample"
                        >
                          <div class="card-body">
                            {{ detail.custom_value }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer justify-content-center" v-if="!closeLabel && pagename != 'qr'">
            <div
              class="quantityInc"
              v-if="productDetail && productDetail.is_sold_out == '0'"
            >
              <div class="number d-flex align-items-center">
                <span
                  class="minus d-flex justify-content-center align-items-center"
                  @click="decrementItem()"
                  >-</span
                >
                <input type="text" :value="quantityTotal" readonly />
                <span
                  class="plus d-flex justify-content-center align-items-center"
                  @click="incrementItem()"
                  >+</span
                >
              </div>
            </div>

            <button
              v-if="productDetail && productDetail.is_sold_out == '0'"
              class="add-to-cart btn btn-outline-warning btn-sm"
              @click="addProductToCart"
            >
              {{ $t("Add To Cart") }}
            </button>
            <!-- <button v-if="productDetail && productDetail.is_sold_out == '0'" class="add-to-cart btn btn-outline-warning btn-sm" @click="addProductToCart">
                        {{$t('Add To Cart')}}(<span v-html="$auth.setting.currency" class="currency"></span>
                        <span v-if="getTotalOptionPrice() > 0 ">{{(getTotalOptionPrice()*this.quantityTotal).toFixed(2)}})</span>
                        <span v-else>{{productDetail.display_price}})</span>
                    </button> -->

            <button
              v-if="
                productDetail &&
                productDetail.is_sold_out != '0' &&
                !customize_skelloader
              "
              class="sold add-to-cart btn btn-outline-warning btn-sm"
            >
              Sold Out
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--Alert Modal start-->
    <AlertModal
      v-if="isAlert"
      :DisplayAlertData="AlertData"
      v-on:modalClose="onModalCloseFun"
    ></AlertModal>
    <!--Alert Modal End-->
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import AlertModal from "../components/AlertModal.vue";
import VueSkeletonLoader from "skeleton-loader-vue";
import { requiredIf } from "vuelidate/lib/validators";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import { CouponTypes, imageErrorHandle } from "../helper/helper";

export default {
  components: {
    AlertModal,
    "skeleton-loader-vue": VueSkeletonLoader,
    VueSlickCarousel,
  },
  props: [
    "productId",
    "restaurantID",
    "restaurant_on_off",
    "pagename",
    "freeBie",
  ],
  data() {
    return {
      imageErrorHandle: imageErrorHandle,
      base_price: 0,
      couponTypes: CouponTypes,
      productDetail: null,
      imgError: "",
      loading: true,
      optionCollection: [],
      selectedCustomisation: {
        customize_type: {},
      },
      selectedCheckbox: [],
      itemTotal: 0,
      quantityTotal: 1,
      closeLabel: false,
      isAlert: false,
      AlertData: {},
      tempProduct: {},
      customize_skelloader: true,
      settings: {
        autoplay: true,
        dots: false,
        arrows: true,
        infinite: true,
        speed: 2000,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0,
        centerMode: false,
        centerPadding: "40px",
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              dots: true,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              initialSlide: 1,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      },
      tags: [],
      rest_offer: [],
    };
  },
  mounted() {
    if (this.restaurant_on_off == "0") {
      this.closeLabel = true;
    } else {
      this.closeLabel = false;
    }

    if (this.offers && this.offers.length > 0) {
      this.rest_offer = [...this.offers];
    }
  },

  watch: {
    // offers are persisted in store, use latest offers once loaded
    offers: function () {
      this.rest_offer = [...(this.offers || [])];
    },
  },

  validations() {
    if (this.productDetail) {
      let data = {
        selectedCustomisation: {
          customize_type: {},
        },
      };
      this.productDetail &&
        this.productDetail.customize_type.forEach((item, index) => {
          let pvalue = null;
          if (
            !this.selectedCustomisation.customize_type[
              "parent_" + item.customize_type_id
            ]
          ) {
            
            this.selectedCustomisation.customize_type[
              "parent_" + item.customize_type_id
            ] = { value: item.is_selection != 1 ? [] : null };

          }
          
          pvalue =
            this.selectedCustomisation.customize_type[
              "parent_" + item.customize_type_id
            ].value;

          data["selectedCustomisation"]["customize_type"][
            "parent_" + item.customize_type_id
          ] = {
            value: {
              crequired: (value) => {
                return item.is_min_selection > 0
                  ? value && value.toString().length > 0
                    ? true
                    : false
                  : true;
              },
              valueBetween: (value) =>
                item.is_selection > 1
                  ? value.length >= item.is_min_selection &&
                    value.length <= item.is_selection
                  : true,
            },
          };
          this.productDetail.customize_type[index].option.forEach((op, ind) => {
            if (
              op.is_default == 1 &&
              this.selectedCustomisation.customize_type[
                "parent_" + op.customize_type_id
              ].flag !== false
            ) {
              //this.isDefaultCheck = true;
              let setvalue =
                this.selectedCustomisation.customize_type[
                  "parent_" + op.customize_type_id
                ].value;

                
              if (setvalue && setvalue != null) {
                if (
                  typeof setvalue == "number" ||
                  typeof setvalue == "string"
                ) {
                  setvalue = op.selection_id;
                } else {
                  if (!setvalue.includes(op.selection_id)) {
                    setvalue.push(op.selection_id);
                  }
                }
              } else {
                this.selectedCustomisation.customize_type[
                  "parent_" + op.customize_type_id
                ].value = op.selection_id;
              }
            }

            this.selectedCustomisation.customize_type[
              "parent_" + op.customize_type_id
            ].flag = false;
            let temp =
              this.selectedCustomisation.customize_type[
                "parent_" + item.customize_type_id
              ]["child_" + op.selection_id];
            if (
              !temp ||
              (pvalue &&
                typeof pvalue == "object" &&
                (pvalue.length == 0 || !pvalue.includes(op.selection_id))) ||
              pvalue == null ||
              pvalue == ""
            ) {
              if (op.is_selection < op.is_min_selection) {
                this.productDetail.customize_type[index].option[
                  ind
                ].is_selection = op.is_min_selection;
              }
              this.selectedCustomisation.customize_type[
                "parent_" + item.customize_type_id
              ]["child_" + op.selection_id] = {
                value:
                  op.is_selection != 1
                    ? []
                    : op.is_selection < op.is_min_selection
                    ? []
                    : null,
              };
              this.selectedCustomisation.customize_type[
                "parent_" + item.customize_type_id
              ]["child_" + op.selection_id].flag = true;
              //this.selectedCustomisation.customize_type['parent_'+item.customize_type_id]['child_'+op.selection_id].flag = true;
            }
            if (op.options.length > 0) {
              
              op.options.forEach((itm, key) => {
                if (
                  itm.is_default == 1 &&
                  this.selectedCustomisation.customize_type[
                    "parent_" + item.customize_type_id
                  ]["child_" + op.selection_id].flag !== false
                ) {
                  let setopvalue =
                    this.selectedCustomisation.customize_type[
                      "parent_" + op.customize_type_id
                    ]["child_" + itm.parent_item_id].value;
                  if (setopvalue != null) {
                    if (
                      typeof setopvalue == "number" ||
                      typeof setopvalue == "string"
                    ) {
                      setopvalue = itm.selection_id;
                    } else {
                      if (setopvalue.length > 0) {
                        setopvalue = setopvalue.filter((c, index) => {
                          return setopvalue.indexOf(c) === index;
                        });
                      }
                      setopvalue.push(itm.selection_id);
                    }
                  }
                  //this.isChildDefaultCheck = true;
                }
              });
            } else {
              if (
                op.is_default == 1 &&
                this.selectedCustomisation.customize_type[
                  "parent_" + item.customize_type_id
                ]["child_" + op.selection_id].flag !== false
              ) {
                let setopvalue =
                  this.selectedCustomisation.customize_type[
                    "parent_" + op.customize_type_id
                  ].value;
                if (setopvalue == null) {
                  this.selectedCustomisation.customize_type[
                    "parent_" + op.customize_type_id
                  ].value = op.selection_id;
                }
              }
            }
            this.selectedCustomisation.customize_type[
              "parent_" + item.customize_type_id
            ]["child_" + op.selection_id].flag = false;
            data["selectedCustomisation"]["customize_type"][
              "parent_" + item.customize_type_id
            ]["child_" + op.selection_id] = {
              value: {
                crequired: (value) => {
                  if (typeof value != "object") {
                    return op.is_min_selection > 0 &&
                      (pvalue && typeof pvalue == "object"
                        ? pvalue.includes(op.selection_id)
                        : pvalue == op.selection_id)
                      ? value && value.toString().length > 0
                        ? true
                        : false
                      : true;
                  } else {
                    return op.is_min_selection > 0 &&
                      (pvalue && typeof pvalue == "object"
                        ? pvalue.includes(op.selection_id)
                        : pvalue == op.selection_id)
                      ? value && value.length > 0
                        ? true
                        : false
                      : true;
                  }
                },

                valueBetween: (value) => {
                  if (typeof value != "object") {
                    return op.is_selection > 1 &&
                      (pvalue && typeof pvalue == "object"
                        ? pvalue.includes(op.selection_id)
                        : pvalue == op.selection_id)
                      ? value &&
                          value.toString().length >= op.is_min_selection &&
                          value &&
                          value.toString().length <= op.is_selection
                      : true;
                  }
                  return op.is_selection > 1 &&
                    (pvalue && typeof pvalue == "object"
                      ? pvalue.includes(op.selection_id)
                      : pvalue == op.selection_id)
                    ? value &&
                        value.length >= op.is_min_selection &&
                        value &&
                        value.length <= op.is_selection
                    : true;
                },
              },
            };
          });
        });
      //this.isDefaultCheck = false;
      return data;
    } else {
      return {};
    }
  },
  computed: {
    ...mapGetters("product", ["cart", "offers"]),
  },

  methods: {
    ...mapActions("product", ["addProductToCart", "getProductDetails"]),
    ...mapMutations("product", ["clearCartItems"]),
    getOfferedPrice(offer, price) {
      let final = price;
      offer.forEach((e) => {
        if (e.coupon_type == this.couponTypes.FLATPRICE) {
          final = e.flat_price;
          return;
        } else if (
          e.coupon_type == this.couponTypes.FLATPERCENTAGE &&
          Number(e.discount_percentage) > 0
        ) {
          final = (
            parseFloat(price) -
            (parseFloat(price) * Number(e.discount_percentage)) / 100
          ).toFixed(2);
          return;
        }
      });
      return final;
    },
    customizationPrice(index, options, itemId) {
      let final = options.selection_price;
      if (options.type == "variation") {
        if (this.rest_offer && this.rest_offer.length > 0) {
          this.rest_offer.forEach((e) => {
            if (
              e.items.includes(Number(itemId)) &&
              this.couponTypes.FLATPRICE == e.coupon_type
            ) {
              if (index == 0 || options.is_default == 1) {
                final = parseFloat(e.flat_price).toFixed(2);
                this.base_price = options.selection_price;
                return;
              } else if (this.base_price < options.selection_price) {
                let diff =
                  Number(options.selection_price) - Number(this.base_price);
                final = Number(e.flat_price) + Number(diff);
                return;
              } else {
                final = parseFloat(e.flat_price).toFixed(2);
                return;
              }
            } else if (
              e.items.includes(Number(itemId)) &&
              this.couponTypes.FLATPERCENTAGE == e.coupon_type &&
              Number(e.discount_percentage) > 0
            ) {
              // same as api, percentage applied on variation price
              final = (
                parseFloat(options.selection_price) -
                (parseFloat(options.selection_price) *
                  Number(e.discount_percentage)) /
                  100
              ).toFixed(2);
              return;
            }
          });
        }
      }
      return final;
    },
    openProductModel: function (itemId, name) {
      // let itemSlug = name.replaceAll(/[^a-zA-Z ]/g,"").replaceAll(" ","-").toLowerCase();
      // if(this.$route.params.item_slug == undefined){
      //     history.pushState({},null,this.$route.path + '/' + encodeURIComponent(itemSlug));
      // }else{
      //     if(this.$route.params.item_slug && this.$route.params.item_slug != itemSlug) {
      //         let str = this.$route.path;
      //         var lastIndex = str.lastIndexOf("/");
      //         str = str.substring(0, lastIndex);
      //         history.pushState({},null,str + '/' + encodeURIComponent(itemSlug));
      //     }
      // }
      this.itemTotal = 0;
      this.quantityTotal = 1;
      this.loading = true;
      this.customize_skelloader = true;
      this.getProductDetails({
        vendor_id: this.$auth.getVendorId(),
        is_langauge: this.$store.state.lang.locale,
        latitude: localStorage.getItem("latitude"),
        starttime: "",
        longitude: localStorage.getItem("longitude"),
        restaurant_id: this.restaurantID,
        date: "",
        item_id: itemId,
      }).then((data) => {
        if (data.code == 200) {
          this.loading = false;
          if (data.Result[0] != undefined && data.Result[0].length != 0) {
            this.customize_skelloader = false;
            this.productDetail = {
              ...data.Result[0],
              selected_type: data.Result[0].customize_type.map((p) => ({
                customize_type_id: p.customize_type_id,
                max_selection: parseInt(p.is_selection),
                min_selection: parseInt(p.is_min_selection),
                selection_name: p.name,

                ...(p.is_selection != 1
                  ? {
                      option: p.option.filter((q) => q.is_default == "1"),
                    }
                  : {
                      option: [],
                    }),
                ...(p.is_selection == 1
                  ? {
                      roption: p.option.find((q) => q.is_default == "1"),
                    }
                  : {
                      roption: undefined,
                    }),
              })),
            };
            this.tags = this.productDetail.menu_item_tags;
          }
        }

        if (this.productDetail && this.productDetail.is_customizable !== 0) {
          this.productDetail.customize_type.forEach((customize) => {
            const parentKey = `parent_${customize.customize_type_id}`;
            let object = {
              [parentKey]: {
                value: customize.is_selection <= 1 ? "" : [],
                flag: false,
              },
            };
            if (customize.option.length > 0) {
              customize.option.forEach((option) => {
                const childKey = `child_${option.selection_id}`;

                if (option.is_default == "1") {
                  if(customize.is_selection <= 1){
                    object[parentKey].value = option.selection_id;
                  }else{
                    object[parentKey].value.push(option.selection_id);
                  }
                }
                object[parentKey][childKey] = {
                  value: [],
                  flag: false,
                };
              });
            }
            this.selectedCustomisation.customize_type = {
              ...this.selectedCustomisation.customize_type,...object
            };
          });
        }
        // console.log(this.selectedCustomisation.customize_type,"Default")
      });
    },

    //Display Total Amount Of item cart
    getTotalOptionPrice() {
      let radioTotal = 0;
      let checkboxTotal = 0;
      let pvalue = null;
      this.productDetail.customize_type.forEach((itm, index) => {
        let parentId = "parent_" + itm.customize_type_id;
        if (
          this.selectedCustomisation.customize_type[
            "parent_" + itm.customize_type_id
          ]
        ) {
          pvalue =
            this.selectedCustomisation.customize_type[
              "parent_" + itm.customize_type_id
            ].value;
        } else {
          pvalue = null;
        }
        if (itm.option) {
          itm.option.forEach((itmoption, key) => {
            if (pvalue && pvalue != null && typeof pvalue != "number") {
              if (
                pvalue &&
                pvalue != null &&
                pvalue.includes(itmoption.selection_id)
              ) {
                radioTotal += itmoption.selection_price;
                if (itmoption.options) {
                  let temp = null;
                  itmoption.options.forEach((option, okey) => {
                    temp =
                      this.selectedCustomisation.customize_type[
                        "parent_" + itm.customize_type_id
                      ]["child_" + option.parent_item_id].value;
                    if (
                      temp &&
                      typeof temp == "number" &&
                      temp == option.selection_id
                    ) {
                      radioTotal += option.selection_price;
                    }
                    if (
                      temp &&
                      typeof temp == "object" &&
                      temp.includes(option.selection_id)
                    ) {
                      radioTotal += option.selection_price;
                    }
                  });
                }
              }
            } else if (pvalue && pvalue != null && typeof pvalue == "number") {
              if (pvalue && pvalue == itmoption.selection_id) {
                radioTotal += itmoption.selection_price;
                if (itmoption.options.length > 0) {
                  let temp = null;
                  itmoption.options.forEach((option, okey) => {
                    temp =
                      this.selectedCustomisation.customize_type[
                        "parent_" + itm.customize_type_id
                      ]["child_" + option.parent_item_id].value;
                    if (
                      temp &&
                      typeof temp == "number" &&
                      temp == option.selection_id
                    ) {
                      radioTotal += option.selection_price;
                    }
                    if (
                      temp &&
                      typeof temp == "object" &&
                      temp.includes(option.selection_id)
                    ) {
                      radioTotal += option.selection_price;
                    }
                  });
                }
              }
            }
          });
        }
      });
      return parseInt(this.productDetail.price) + radioTotal + checkboxTotal;
    },

    onModalCloseFun(value) {
      this.isAlert = false;
      if (value == "yes") {
        this.$store.commit("product/clearCartItems");
        this.addToCartItem(this.tempProduct);
      }
    },
    getOfferes(itemId) {
      let array = [];
      this.rest_offer.forEach((e) => {
        if (
          e.items.includes(Number(itemId)) &&
          (this.couponTypes.BOGO == e.coupon_type ||
            this.couponTypes.FREEBIE == e.coupon_type ||
            this.couponTypes.FLATPRICE == e.coupon_type ||
            this.couponTypes.FLATPERCENTAGE == e.coupon_type)
        ) {
          array.push({ ...e, item_id: itemId });
        }
      });
      return array;
    },
    addProductToCart() {
      this.$v.$touch();
      if (this.$v.selectedCustomisation.customize_type.$invalid) {
        return false;
      }
      if (this.freeBie) {
        this.$emit("hideFreeBei", true);
      }

      let pvalue = null;
      let arraySelectCustoizeID = [];
      let customisation = [];
      let arraySelectCustoizePrice = [];
      let arraySelectCustoizPackge = [];
      let selected_type = [];
      let packagingCharge = 0;
      arraySelectCustoizPackge.push(
        parseInt(this.productDetail.packaging_charge)
      );

      this.productDetail.customize_type.forEach((itm, index) => {
        let parentId = "parent_" + itm.customize_type_id;
        pvalue =
          this.selectedCustomisation.customize_type[
            "parent_" + itm.customize_type_id
          ].value;
        var arrangeItem = [];
        if (itm.option) {
          itm.option.forEach((itmoption) => {
            if (pvalue && pvalue != null && typeof pvalue != "number") {
              if (
                pvalue &&
                pvalue != null &&
                pvalue.includes(itmoption.selection_id)
              ) {
                arrangeItem.push({ id: itmoption.selection_id });
                arraySelectCustoizeID.push(itmoption.selection_id);
                arraySelectCustoizePrice.push(itmoption.selection_price);
                selected_type.push(itmoption.selection_name);
                arraySelectCustoizPackge.push(
                  parseInt(itmoption.packaging_charge)
                );
                if (itmoption.options) {
                  let temp = null;
                  itmoption.options.forEach((option, okey) => {
                    temp =
                      this.selectedCustomisation.customize_type[
                        "parent_" + itm.customize_type_id
                      ]["child_" + option.parent_item_id].value;
                    if (
                      temp &&
                      typeof temp == "number" &&
                      temp == option.selection_id
                    ) {
                      arraySelectCustoizeID.push(option.selection_id);
                      arraySelectCustoizePrice.push(option.selection_price);
                      selected_type.push(option.selection_name);
                      arraySelectCustoizPackge.push(
                        parseInt(option.packaging_charge)
                      );
                    }
                    if (
                      temp &&
                      typeof temp == "object" &&
                      temp.includes(option.selection_id)
                    ) {
                      arraySelectCustoizeID.push(option.selection_id);
                      arraySelectCustoizePrice.push(option.selection_price);
                      selected_type.push(option.selection_name);
                      arraySelectCustoizPackge.push(
                        parseInt(option.packaging_charge)
                      );
                    }
                  });
                }
              }
            } else if (pvalue && pvalue != null && typeof pvalue == "number") {
              if (pvalue && pvalue == itmoption.selection_id) {
                arrangeItem.push({ id: itmoption.selection_id });
                arraySelectCustoizeID.push(itmoption.selection_id);
                arraySelectCustoizePrice.push(itmoption.selection_price);
                selected_type.push(itmoption.selection_name);
                arraySelectCustoizPackge.push(
                  parseInt(itmoption.packaging_charge)
                );
                if (itmoption.options) {
                  let temp = null;
                  itmoption.options.forEach((option, okey) => {
                    temp =
                      this.selectedCustomisation.customize_type[
                        "parent_" + itm.customize_type_id
                      ]["child_" + option.parent_item_id].value;

                    if (
                      temp &&
                      typeof temp == "number" &&
                      temp == option.selection_id
                    ) {
                      arraySelectCustoizeID.push(option.selection_id);
                      arraySelectCustoizePrice.push(option.selection_price);
                      selected_type.push(option.selection_name);
                      arraySelectCustoizPackge.push(
                        parseInt(option.packaging_charge)
                      );
                    }
                    if (
                      temp &&
                      typeof temp == "object" &&
                      temp.includes(option.selection_id)
                    ) {
                      arraySelectCustoizeID.push(option.selection_id);
                      arraySelectCustoizePrice.push(option.selection_price);
                      selected_type.push(option.selection_name);
                      arraySelectCustoizPackge.push(
                        parseInt(option.packaging_charge)
                      );
                    }
                  });
                }
              }
            }
          });
          if (arrangeItem && arrangeItem.length > 0) {
            customisation.push({
              id: itm.customize_type_id,
              selected: arrangeItem,
            });
          }
        }
      });
      // console.log("arraySelectCustoizPackge",arraySelectCustoizPackge);
      packagingCharge = arraySelectCustoizPackge.reduce(
        (partialSum, a) => partialSum + a,
        0
      );
      // console.log("packagingCharge",packagingCharge);
      let savemrp = 0;
      if (this.productDetail.price < this.productDetail.mrp) {
        savemrp = this.productDetail.mrp - this.productDetail.price;
      }

      let offerArray = [];
      offerArray = this.getOfferes(parseInt(this.productDetail.item_id));
      if (!this.freeBie) {
        if (offerArray.length > 0) {
          if (offerArray[0].coupon_type == this.couponTypes.FREEBIE) {
            offerArray.length = 0;
          }
        }
      }

      var AddToCartItemArray = {
        restaurant_id: this.restaurantID,
        item_id: parseInt(this.productDetail.item_id),
        item_name: this.productDetail.item_name,
        price: this.getTotalOptionPrice(),
        quantity: this.quantityTotal,
        itemTotalQuantity: this.productDetail.quantity,
        selected_type: selected_type,
        selectCustoizeID: arraySelectCustoizeID,
        selectCustoizePrice: arraySelectCustoizePrice,
        item_type: this.productDetail.item_type,
        item_price: this.productDetail.price,
        image: this.productDetail.image,
        saveprice: savemrp,
        packageCharge: packagingCharge,
        customisation: customisation,
        // offer: this.getOfferes(parseInt(this.productDetail.item_id)),
        offer: offerArray,
      };
      var checkRestarant = this.cart.find(
        (ele) => ele.restaurant_id == this.restaurantID
      );
      if (this.cart.length) {
        if (checkRestarant) {
          this.addToCartItem(AddToCartItemArray);
        } else {
          this.AlertData = {
            displayMessage:
              this.$t("Your cart contain items from another ") +
              this.$t(this.$auth && this.$auth.getRestaurantName()) +
              this.$t("Do you wish to clear cart and start a new order here?"),
            isSetClass: "prdct-modal-cls",
          };
          this.isAlert = true;
          this.tempProduct = AddToCartItemArray;
          window.$("#item-popup").modal("hide");
          window.$(this.$refs.AlertModal).modal();
        }
      } else {
        this.addToCartItem(AddToCartItemArray);
      }
    },

    addToCartItem(product) {
      const cartItemIndex = this.cart.findIndex(
        (item) => parseInt(item.item_id) === parseInt(product.item_id)
      );
      let totalQnt = 0;
      if (cartItemIndex != undefined && cartItemIndex != -1) {
        var itemTotalQuantity = this.cart[cartItemIndex].quantity;
        totalQnt = this.cart[cartItemIndex].quantity + product.quantity;
      } else {
        totalQnt = product.quantity;
      }

      if (totalQnt <= product.itemTotalQuantity) {
        this.$store.dispatch("product/addProductToCart", product);
        window.$("#item-popup").modal("hide");
      } else {
        alert(this.$t("Maximum items reached"));
      }
    },

    checkNested(e, cust_id) {
      this.selectedCustomisation.customize_type = {
        ...this.selectedCustomisation.customize_type,
        ["parent_" + cust_id]: { value: e.target.value },
      };
    },

    checkNestedSub(e, cust_id) {
      
      let types = Object.keys(this.selectedCustomisation.customize_type);
      this.selectedCustomisation.customize_type = {
        ...this.selectedCustomisation.customize_type,
        /* ...(types.reduce((acc,ire) => {
          acc[ire] = {...this.selectedCustomisation.customize_type[ire]};
          return acc;
          },{})) */
      };
      // console.log( this.selectedCustomisation.customize_type," this.selectedCustomisation.customize_type")
    },

    incrementItem() {
      if (this.productDetail.quantity > this.quantityTotal) {
        this.quantityTotal++;
      } else {
        alert(this.$t("Maximum items reached"));
      }
    },

    decrementItem() {
      if (this.quantityTotal != 1) {
        this.quantityTotal--;
      }
    },

    checkInCart(itemId) {
      var checkItem = this.cart.find((ele) => ele.item_id == itemId);
      if (checkItem) {
        return false;
      } else {
        return true;
      }
    },

    onImgError() {
      this.imgError = true;
    },
  },
};
</script>
<style>
.silkprod {
  padding-bottom: 20px;
}

.silkprod .testimonial-item .item-img {
  display: block;
  width: 100%;
  float: left;
  height: 185px;
  -o-object-fit: cover;
  object-fit: cover;
  border-radius: 10px;
}

.silkprod .slick-arrow {
  width: 36px;
  border: 1px solid rgba(var(--theme-primary));
  border-radius: 50%;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.silkprod .slick-prev::before {
  content: "<";
  color: #555555;
  line-height: 0.2;
  font-size: 20px;
}

.silkprod .slick-next::before {
  content: ">";
  line-height: 0.2;
  color: #555555;
  font-size: 20px;
}

.silkprod .slick-prev {
  display: block;
  bottom: 0px !important;
  z-index: 99 !important;
  top: auto !important;
  left: 41% !important;
}

.silkprod .slick-next {
  display: block;
  bottom: 0px !important;
  z-index: 99 !important;
  top: auto;
  right: 41%;
}

@media all and (max-width: 767px) {
  .cust-prdt-table .modal-content {
    width: 95%;
  }

  .silkprod .slick-prev {
    left: 35% !important;
  }

  .silkprod .slick-next {
    right: 35% !important;
  }
}
</style>
